define('presentation/signup/presentationObjects/planPresentationObject',[
    'i18next',
    'constants/billingPackageTypeConstants'
], function() {
    return function() {
        const self = this;

        const _billingPackageTypes = require('constants/billingPackageTypeConstants');
        const _i18n = require('i18next');

        self.affiliateId = ko.observable(null);
        self.billingPackageId = ko.observable(null);
        self.packageId = ko.observable(null);
        self.type = ko.observable(0);
        self.name = ko.observable("");
        self.price = ko.observable("");
        self.includedItems = ko.observable("");
        self.isSignupForCustomer = ko.observable(false);
        self.isSignatureService = ko.observable(false);

        self.isAnyPackageSelected = ko.pureComputed(() => {
            return self.packageId() !== null;
        });

        self.buttonText = ko.pureComputed(() => {
            return self.packageId() !== null ? _i18n.t('signupPlans:buttonChange') : _i18n.t('signupPlans:buttonSelect');
        });

        self.label =  ko.pureComputed(() => {
            switch (self.type()){
                case _billingPackageTypes.telephony.id:
                    return _i18n.t('signupPlans:labelTelephony');
                case _billingPackageTypes.liveReceptionist.id:
                    return _i18n.t('signupPlans:labelLiveReceptionist');
                case _billingPackageTypes.webChat.id:
                    return _i18n.t('signupPlans:labelWebChat');
                case _billingPackageTypes.outboundCalling.id:
                    return _i18n.t('signupPlans:labelOutboundCalling');
                default:
                    return "";
            }
        });

        self.showRemovePlan = ko.pureComputed(() => {
            return self.packageId() !== null;
        });
    };
});
